import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Outlet, useParams } from "react-router-dom"
import { RiMenuLine } from "react-icons/ri"

import CourseReviewModal from "../components/core/ViewCourse/CourseReviewModal"
import VideoDetailsSidebar from "../components/core/ViewCourse/VideoDetailsSidebar"
import { getFullDetailsOfCourse } from "../services/operations/courseDetailsAPI"
import {
  setCompletedLectures,
  setCourseSectionData,
  setEntireCourseData,
  setTotalNoOfLectures,
} from "../slices/viewCourseSlice"

export default function ViewCourse() {
  const { courseId } = useParams()
  const { token } = useSelector((state) => state.auth)
  const dispatch = useDispatch()
  const [reviewModal, setReviewModal] = useState(false)
  const [sidebarOpen, setSidebarOpen] = useState(true)

  const { courseEntireData, totalNoOfLectures, completedLectures } =
    useSelector((state) => state.viewCourse)

  useEffect(() => {
    ;(async () => {
      const courseData = await getFullDetailsOfCourse(courseId, token)
      dispatch(setCourseSectionData(courseData.courseDetails.courseContent))
      dispatch(setEntireCourseData(courseData.courseDetails))
      dispatch(setCompletedLectures(courseData.completedVideos))
      let lectures = 0
      courseData?.courseDetails?.courseContent?.forEach((sec) => {
        lectures += sec.subSection.length
      })
      dispatch(setTotalNoOfLectures(lectures))
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="flex h-[calc(100vh-3.5rem)] flex-col overflow-hidden bg-richblack-900">
      {/* ── Top bar ──────────────────────────────────────────────── */}
      <div className="flex flex-shrink-0 items-center gap-3 border-b border-richblack-700 bg-richblack-800 px-4 py-2.5">
        <button
          onClick={() => setSidebarOpen((p) => !p)}
          className="flex-shrink-0 rounded-lg p-1.5 text-richblack-300 transition-colors hover:bg-richblack-700 hover:text-richblack-5"
          aria-label="Toggle sidebar"
        >
          <RiMenuLine size={20} />
        </button>

        <p className="min-w-0 flex-1 truncate text-sm font-medium text-richblack-5">
          {courseEntireData?.courseName}
        </p>

        <span className="flex-shrink-0 rounded-full bg-richblack-700 px-2.5 py-0.5 text-xs font-medium text-richblack-200">
          {completedLectures?.length} / {totalNoOfLectures}
        </span>
      </div>

      {/* ── Body ─────────────────────────────────────────────────── */}
      <div className="relative flex flex-1 overflow-hidden">
        {/* Mobile backdrop */}
        {sidebarOpen && (
          <div
            className="absolute inset-0 z-30 bg-richblack-900/70 backdrop-blur-sm md:hidden"
            onClick={() => setSidebarOpen(false)}
          />
        )}

        {/* Sidebar */}
        <aside
          className={`
            absolute left-0 top-0 z-40 h-full w-72 flex-shrink-0
            border-r border-richblack-700 bg-richblack-800
            transition-all duration-300 ease-in-out
            md:relative md:z-auto
            ${sidebarOpen
              ? "translate-x-0 md:w-72"
              : "-translate-x-full md:translate-x-0 md:w-0 md:overflow-hidden md:border-0"
            }
          `}
        >
          <VideoDetailsSidebar
            setReviewModal={setReviewModal}
            setSidebarOpen={setSidebarOpen}
          />
        </aside>

        {/* Video content */}
        <main className="flex-1 overflow-y-auto">
          <div className="mx-auto max-w-5xl px-4 py-2 md:px-6">
            <Outlet />
          </div>
        </main>
      </div>

      {reviewModal && <CourseReviewModal setReviewModal={setReviewModal} />}
    </div>
  )
}
